/**
 * testimonials.js — Minimal scroll-snap slider navigation.
 * Prev/next buttons scroll the container by one card width.
 */

(function () {
  'use strict';

  var slider = document.querySelector('[data-testimonials-slider]');
  if (!slider) return;

  var prevBtn = document.querySelector('[data-testimonials-prev]');
  var nextBtn = document.querySelector('[data-testimonials-next]');
  if (!prevBtn || !nextBtn) return;

  function getScrollAmount() {
    var card = slider.querySelector('.testimonial-card');
    if (!card) return 300;
    var style = window.getComputedStyle(slider);
    var gap = parseInt(style.gap, 10) || 15;
    return card.offsetWidth + gap;
  }

  prevBtn.addEventListener('click', function () {
    slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', function () {
    slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
  });

  /* "Read Full" / "Collapse" toggle */
  slider.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-testimonial-toggle]');
    if (!toggle) return;

    var card = toggle.closest('.testimonial-card');
    if (!card) return;

    var text = card.querySelector('.testimonial-card__text');
    if (!text) return;

    var isExpanded = text.classList.toggle('testimonial-card__text--expanded');
    toggle.classList.toggle('testimonial-card__toggle--expanded', isExpanded);

    var label = toggle.querySelector('.link');
    if (label) {
      label.textContent = isExpanded ? 'Collapse' : 'Read Full';
    }
  });
})();
